/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_PrevInputs */



/**
* | output |
* | --- |
* | "Prev" |
*
* @param {Tournaments_PrevInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournaments_prev = /** @type {((inputs?: Tournaments_PrevInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_PrevInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Préc")
	if (locale === "es") return /** @type {LocalizedString} */ ("Anterior")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Ant")
	if (locale === "it") return /** @type {LocalizedString} */ ("Prec")
	return /** @type {LocalizedString} */ ("Prev")
});